import { isSuccess, type Result } from '@carvana/merch-result';
import { httpWithAuth } from '~/clients';
import { getCreateQuoteAuth } from '~/constants/endpoints';
import Quote from '~/contracts/vdp/Quote';

type QuoteRequest = {
  routeId?: string;
  stateAbbreviation: string;
  vehicleId: number;
};

type QuoteResponse = Result<{
  correlationId: string;
  quote: Quote;
}>;

export default async function fetchTransitChargeAuthenticated(
  controller: AbortController,
  request: QuoteRequest,
  associatedVdpEventId: string
): Promise<Quote> {
  const { data } = await httpWithAuth.post<QuoteResponse>(
    getCreateQuoteAuth({ currentPageUrl: window.location.href }),
    request,
    {
      headers: {
        'x-client-id': 'e902dfb1-f373-450d-8cca-9db2e12bfce5',
        'x-correlation-id': associatedVdpEventId
      },
      signal: controller.signal
    }
  );

  if (isSuccess(data)) {
    return data.content.quote;
  }

  throw new Error(data.errorMessage);
}
